import { render } from "./returnVisit.vue?vue&type=template&id=590a1bd2&scoped=true"
import script from "./returnVisit.vue?vue&type=script&lang=js"
export * from "./returnVisit.vue?vue&type=script&lang=js"

import "./returnVisit.vue?vue&type=style&index=0&id=590a1bd2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-590a1bd2"

export default script